module.exports = __webpack_public_path__ + "media/images/pic/contact/justyna-szybinska-075858315644e24bf570d864e6aff3b6.jpeg";